export type AustralianStateCode = "NSW" | "ACT" | "VIC" | "QLD" | "WA" | "SA" | "TAS" | "NT";

export const australianStateCodes: AustralianStateCode[] = ["NSW", "ACT", "VIC", "QLD", "WA", "SA", "TAS", "NT"];

/*-- Accepted spellings for each state, so a Storyblok "location" can be authored as "NSW & ACT",
     "New South Wales / ACT", "Victoria", etc. --*/
const stateAliases: Record<AustralianStateCode, string[]> = {
  NSW: ["NSW", "NEW SOUTH WALES"],
  ACT: ["ACT", "AUSTRALIAN CAPITAL TERRITORY", "CANBERRA"],
  VIC: ["VIC", "VICTORIA"],
  QLD: ["QLD", "QUEENSLAND"],
  WA: ["WA", "WESTERN AUSTRALIA"],
  SA: ["SA", "SOUTH AUSTRALIA"],
  TAS: ["TAS", "TASMANIA"],
  NT: ["NT", "NORTHERN TERRITORY"],
};

/*-- Reduce a location to space-separated upper-case words, padded so every comparison below is
     word-bounded. Without the boundaries "WA" would match inside "NEW SOUTH WALES". --*/
const normalise = (value: string): string =>
  ` ${value
    .replace(/[^a-z]+/gi, " ")
    .trim()
    .toUpperCase()} `;

export const isAustralianStateCode = (value: string): value is AustralianStateCode =>
  (australianStateCodes as string[]).includes(value);

const matchLocationToState = (location: string | undefined, state: AustralianStateCode): boolean => {
  if (!location) {
    return false;
  }

  const normalisedLocation = normalise(location);

  return stateAliases[state].some((alias: string) => normalisedLocation.includes(` ${alias} `));
};

export default matchLocationToState;
